import findResult, { findWithCodes, removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { requestMarkdownCategories } from '../constants';

const initialState = {
  markdowns: {
    open: {
      results: [],
    },
  },
};

export const findRequestMarkdown = ({ markdowns }, { category, code }) => findResult(markdowns, category, code);

const findAllRequestMarkdowns = ({ markdowns }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(markdowns, requestMarkdownCategories, codes);
};

export const destroyRequestsMarkdown = withDraft((draft, { items }) => {
  findAllRequestMarkdowns(draft, { items }).forEach((category) => {
    items.forEach(({ code }) => {
      const item = findResult(draft.markdowns, category, code);
      if (item) {
        draft.markdowns[category].results = (
          removeItemByCode(draft.markdowns[category].results, item)
        );
      }
    });
  });
});

export default initialState;
